import React from "react";

const AccountResult = ({ account }) => {
  

  return (
    <div className="account-result p-3">
      <div className="header mb-3">
        <h3 className="text-primary mb-1">{account.account_name}</h3>
        <p className="text-muted">{account.description}</p>
      </div>

      <div className="details mb-4">
        <div className="row">
          <div className="col-6">
            <strong className="d-block text-secondary">Account Number</strong>
            <span>{account.account_number}</span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Balance</strong>
            <span>
              {account.balance !== null ? `$${account.balance}` : "N/A"}
            </span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Account Hierarchy</strong>
            <span>
              {account.is_sub_account_of === "0"
                ? "Primitive Account"
                : "Main Account"}
            </span>
          </div>
          <div className="col-6">
            <strong className="d-block text-secondary">Account Category</strong>
            <span>{account.account_type}</span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 text-center">
          <button className="btn btn-outline-primary mr-2">
            <i className="fas fa-edit mr-2"></i> Edit Account
          </button>
          <button className="btn btn-outline-danger">
            <i className="fas fa-trash-alt mr-2"></i> Delete Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountResult;
